import API from 'src/api'
import { http } from '../boot/axios'

export default {
  GRAPHQL_URL: API.GRAPHQL_URL,
  EVENT_GRAPHQL_URL: API.GRAPHQL_URL + 'calendar/events/',
  fetchAll (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}calendar`, { params: payload })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}calendar/create`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  createRecurrence (event) {
    const recurrence = event.recurrence
    recurrence.time = event.time
    recurrence.allDay = event.allDay
    recurrence.startDate = event.dates[0]
    // have to set the end date
    const payload = {
      model: 'Event',
      base_model: event,
      recurrence: recurrence,
      end_date: recurrence.endDate
    }
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}recurrences`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  update (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}calendar/update/${payload.id}`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  updateEvent (event) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}calendar/updateEvent/${event.id}`, event)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  updateForOtherEvent (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}calendar/updateEventOthers/${payload.eventId}`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  updateRecurrence (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}recurrences/update/${payload.recurrence_id}`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  toggleStatus (id) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}calendar/toggle-status/${id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  generateUUID (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}calendar/generate-uuid`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  getGuests (eventId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}calendar/guests/${eventId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  getSetLocations (eventId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}calendar/locationsSet/${eventId}`)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  delete (event_id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.EVENT_GRAPHQL_URL + event_id}`)
        .then(response => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteGroup (eventId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.EVENT_GRAPHQL_URL}group/${eventId}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  deleteEventRecurrence (eventId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}events/recurrence/${eventId}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  // TASK ASSIGNMENTS
  // Fetch Agenda events from new Agenda
  fetchDailyAgenda (days) {
    const now = new Date()
    const today = {
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      days: days
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}agenda/self`, { params: today })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}
